import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { useConnectionCheckPolling } from "./useConnectionCheckPolling";

/**
 * ネットワークエラーが発生した際にSnackbarを表示する
 */
export const useConnectionCheckPollingForSnackbar = () => {
  const $ = _c(6);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      pollInterval: 5000
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    error
  } = useConnectionCheckPolling(t0);
  const [open, setOpen] = useState(false);
  let t1;
  let t2;
  if ($[1] !== error) {
    t1 = () => {
      if (error) {
        setOpen(true);
      }
    };
    t2 = [error];
    $[1] = error;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] !== open) {
    t3 = {
      open,
      setOpen
    };
    $[4] = open;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};